import { Quote, Star } from "lucide-react";
import { ChapterHeading, Reveal } from "./Reveal";

const REVIEWS = [
  {
    name: "Anurag",
    text: "Hotel is very close to all the places. Very professional staff.",
    rating: 5,
  },
  {
    name: "Dey",
    text: "Fantastic stay at Pipewalas House.",
    rating: 5,
  },
  {
    name: "Sharma",
    text: "Thanks to all the staff and management of Pipewalas House & Homestay for the hospitality.",
    rating: 4.5,
  },
  {
    name: "Sahil",
    text: "Affordable room with good facilities. Good room and big.",
    rating: 4,
  },
];

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-40">
    <ChapterHeading number="04" label="Guest Voices" testId="reviews-chapter" />

    <div className="grid gap-16 md:grid-cols-12">
      <Reveal className="md:col-span-4">
        <div data-testid="reviews-rating" className="flex items-end gap-4">
          <span className="font-serif text-8xl leading-none tracking-tight text-[#F5F5F0]">4.4</span>
          <div className="pb-2">
            <div className="flex gap-1">
              {[...Array(4)].map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-[#C5A059] text-[#C5A059]" />
              ))}
              <Star className="h-4 w-4 text-[#C5A059]" />
            </div>
            <p className="mt-2 text-xs uppercase tracking-[0.25em] text-[#A1A1AA]">on Google</p>
          </div>
        </div>
        <h2 className="mt-10 font-serif text-4xl leading-[1.05] tracking-tight text-[#F5F5F0] sm:text-5xl">
          Words from the <em className="font-light italic text-[#C5A059]">ghatside</em>.
        </h2>
      </Reveal>

      <div className="grid gap-5 md:col-span-7 md:col-start-6">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={0.12 + i * 0.1}>
            <figure
              data-testid={`review-${r.name.toLowerCase()}`}
              className="group rounded-2xl border border-white/5 bg-[#121214] p-8 transition-[transform,border-color] duration-500 hover:scale-[1.01] hover:border-[#C5A059]/30 md:p-10"
            >
              <Quote className="h-6 w-6 text-[#C5A059]/60" />
              <blockquote className="mt-5 font-serif text-2xl font-light leading-snug text-[#F5F5F0] md:text-3xl">
                &ldquo;{r.text}&rdquo;
              </blockquote>
              <figcaption className="mt-6 flex items-center justify-between">
                <span className="text-sm font-medium uppercase tracking-[0.2em] text-[#A1A1AA]">
                  {r.name}
                </span>
                <span className="flex gap-1">
                  {[...Array(Math.floor(r.rating))].map((_, j) => (
                    <Star key={j} className="h-3.5 w-3.5 fill-[#C5A059] text-[#C5A059]" />
                  ))}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
        <Reveal delay={0.4}>
          <p className="text-xs text-[#A1A1AA]/70">
            Real guest reviews from the property&rsquo;s public listings.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
